import { LANGUAGE } from 'shared-components';

import { DateFormats } from 'app/shared/constants/date-formats';

export const CustomDateLocalizedFormats = {
  [LANGUAGE.ENGLISH_CANADA.toLowerCase()]: {
    [DateFormats.KH_SHORTEST]: 'MMM d'
  },
  [LANGUAGE.FRENCH_CANADA.toLowerCase()]: {
    [DateFormats.KH_SHORTEST]: 'd MMM'
  },
  [LANGUAGE.SPANISH_MEXICO.toLowerCase()]: {
    [DateFormats.KH_SHORTEST]: 'd \'de\' MMM'
  }
};
